module.exports = __webpack_public_path__ + "static/media/ic_category_one.7b5a9445.svg";